<template>
  <h1 class="title">
    <slot></slot>
    <span v-if="hasCount" class="is-small">
      ({{ items | count }} {{ itemName }})
    </span>
  </h1>
</template>

<script>
export default {
  name: 'TableTitle',
  props: {
    hasCount: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array
    },
    itemName: {
      type: String,
      default: 'items'
    }
  }
};
</script>

<style></style>
